import NAME from "./constants";

export const GET = NAME + "/GET";
export const GET_FULFILLED = NAME + "/GET_FULFILLED";
export const GET_REJECTED = NAME + "/GET_REJECTED";

export const SEARCH = NAME + "/SEARCH";
export const SEARCH_FULFILLED = NAME + "/SEARCH_FULFILLED";
export const SEARCH_REJECTED = NAME + "/SEARCH_REJECTED";
